import { UIOnlineFriendController } from '../../../shared/scripts/ui_friends/UIOnlineFriendController.ts';
import { UIMInviteFriendsBottomDrawer } from '../ui_popup/UIMInviteFriendsBottomDrawer.ts';
import { UIUrlController } from '../../../shared/scripts/ui_html/UIUrlController.ts';
import { notificationController } from '../../../shared/scripts/EntryShared.ts';
import { UITopNotificationType } from '../../../shared/scripts/notifications/UINotificationController.ts';
export class UIMOnlineFriendController extends UIOnlineFriendController {
    updateFriendOnlineStatus(friendData) {
        UIMInviteFriendsBottomDrawer.updateFriendOnlineStatus(friendData);
        super.updateFriendOnlineStatus(friendData);
    }
    updateAllFriendsOnlineStatus(friends) {
        UIMInviteFriendsBottomDrawer.updateFriendList(friends);
        super.updateAllFriendsOnlineStatus(friends);
    }
    friendRespondedToRoomInvite(responseData) {
        var _UIMInviteFriendsBottomDrawer_friendListController;
        if (responseData.response) return;
        super.friendRespondedToRoomInvite(responseData);
        (_UIMInviteFriendsBottomDrawer_friendListController = UIMInviteFriendsBottomDrawer.friendListController) === null || _UIMInviteFriendsBottomDrawer_friendListController === void 0 ? void 0 : _UIMInviteFriendsBottomDrawer_friendListController.toggleFriendInviteButtonState(responseData.responderUserId, true);
    }
    // eslint-disable-next-line class-methods-use-this
    roomInviteSentToFriendSuccessfully(receiverUserId) {
        var _UIMInviteFriendsBottomDrawer_friendListController;
        const roomId = UIUrlController.getRoomIdFromUrl();
        if (!roomId) return;
        (_UIMInviteFriendsBottomDrawer_friendListController = UIMInviteFriendsBottomDrawer.friendListController) === null || _UIMInviteFriendsBottomDrawer_friendListController === void 0 ? void 0 : _UIMInviteFriendsBottomDrawer_friendListController.toggleFriendInviteButtonState(receiverUserId, false);
    }
    // eslint-disable-next-line class-methods-use-this
    showNotification(icon, translationObj) {
        notificationController.showNotification(icon, translationObj);
    }
    // eslint-disable-next-line class-methods-use-this
    showJoinRoomNotification(icon, translationObj, roomInvite) {
        notificationController.show(translationObj, UITopNotificationType.Information, {
            key: 'strings:homePage.ctas.joinRoom'
        }, ()=>UIOnlineFriendController.respondToFriendRoomInvite(roomInvite.roomId, true, roomInvite.senderUserId), undefined);
    }
}
